import type { CreditJournal } from "@pax/api-contract/accounting/v1alpha1";

const journalLabels: Record<CreditJournal, string> = {
  aiSettlement: "AI usage",
  chargebackRemoval: "Payment disputed",
  closureRemoval: "Account closed",
  compensationGrant: "Compensation",
  pendingCreatorReward: "Pending creator reward",
  creatorRewardDeposit: "Creator reward deposit",
  dailyExpiration: "Daily credits expired",
  dailyGrant: "Daily credits",
  debtRepayment: "Debt repaid",
  failedPaymentRemoval: "Failed payment",
  moderationExpiration: "Moderation credits expired",
  moderationGrant: "Moderation credits",
  openingBalance: "Opening balance",
  otherReward: "Reward",
  purchasedCredits: "Purchase",
  refundRemoval: "Refund",
  signupGrant: "Signup bonus",
  sponsorshipGrant: "Sponsorship",
  subscriptionGrant: "Subscription",
  supportGrant: "Support grant",
  supportRemoval: "Support removal",
};

const camelCase = (code: string) =>
  code.replace(/_([a-z0-9])/g, (_, letter: string) => letter.toUpperCase());

/** What a journal means to a person. Takes the ledger's `support_grant` or the API's `supportGrant`. */
export function journalLabel(code: string): string {
  return journalLabels[camelCase(code) as CreditJournal] ?? readableCode(code);
}

/** A code with no label of its own, as words: `failed_payment_removal` reads "Failed payment removal". */
export function readableCode(code: string): string {
  const words = code
    .replace(/_/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}
